import axios from 'axios';

// // Debug the API URL
// console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000'; // Match Laravel default port

// console.log('API_BASE_URL:', API_BASE_URL);

export const API_ENDPOINTS = {
  PRODUCTS:{
    BASE: `${API_BASE_URL}/api/products`,
    CREATE: `${API_BASE_URL}/api/products`,
    EDIT: (id) => `${API_BASE_URL}/api/products/${id}`,
    DELETE: (id) => `${API_BASE_URL}/api/products/${id}`,
    GET: (id) => `${API_BASE_URL}/api/products/${id}`,
  },

  AUTH: {
    LOGIN: `${API_BASE_URL}/api/login`,
    REGISTER: `${API_BASE_URL}/api/register`,
    LOGOUT: `${API_BASE_URL}/api/logout`,
    USER: `${API_BASE_URL}/api/user`
  },
  ROLES: {
    BASE: `${API_BASE_URL}/api/roles`,
    PERMISSIONS: (roleId) => `${API_BASE_URL}/api/roles/${roleId}/permissions` // Updated to match backend
  },
  PERMISSIONS: {
    BASE: `${API_BASE_URL}/api/permissions`,
    PRODUCTS: `${API_BASE_URL}/api/permissions/products`

  },
  USERS: {
    BASE: `${API_BASE_URL}/api/users`,
    ADD: `${API_BASE_URL}/api/users`, // POST for creating user
    EDIT: (userId) => `${API_BASE_URL}/api/users/${userId}`, 
    DELETE: (userId) => `${API_BASE_URL}/api/users/${userId}`,
    ROLES: (userId) => `${API_BASE_URL}/api/users/${userId}/roles`,
    RESET_PASSWORD: (userId) => `${API_BASE_URL}/api/users/reset/${userId}`
  },
  APPLICATION_TYPES: {
    BASE: `${API_BASE_URL}/api/application-setting-types`,
    CREATE: `${API_BASE_URL}/api/application-setting-types`,
    EDIT: (typeId) => `${API_BASE_URL}/api/application-setting-types/${typeId}`,
    DELETE: (typeId) => `${API_BASE_URL}/api/application-setting-types/${typeId}`,
    SETTINGS: (typeId) => `${API_BASE_URL}/api/application-setting-types/${typeId}/settings` // Add this
  },

  APPLICATION_SETTINGS: {
    BASE: `${API_BASE_URL}/api/application-settings`,
    CREATE: `${API_BASE_URL}/api/application-settings`,
    EDIT: (settingId) => `${API_BASE_URL}/api/application-settings/${settingId}`,
    DELETE: (settingId) => `${API_BASE_URL}/api/application-settings/${settingId}`,
    BY_TYPE: (typeSlug) => `${API_BASE_URL}/api/application-settings/type/${typeSlug}`,
    BY_TYPE_ID: (typeId) => `${API_BASE_URL}/api/application-settings/type-id/${typeId}`
  },

  REGIONS:{
    BASE: `${API_BASE_URL}/api/regions`,
    CREATE : `${API_BASE_URL}/api/regions`,
    EDIT : (id) => `${API_BASE_URL}/api/regions/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/regions/${id}`,
    GET: (id) => `${API_BASE_URL}/api/regions/${id}`,
    PUBLISH : (id) => `${API_BASE_URL}/api/regions/publish/${id}`
  },

  USER_TYPES:{
    BASE: `${API_BASE_URL}/api/user-types`,
    CREATE : `${API_BASE_URL}/api/user-types`,
    EDIT : (id) => `${API_BASE_URL}/api/user-types/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/user-types/${id}`,
    GET: (id) => `${API_BASE_URL}/api/user-types/${id}`
  },

  PAYMENT_TERMS:{
    BASE: `${API_BASE_URL}/api/payment-terms`,
    CREATE : `${API_BASE_URL}/api/payment-terms`,
    EDIT : (id) => `${API_BASE_URL}/api/payment-terms/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/payment-terms/${id}`,
    GET: (id) => `${API_BASE_URL}/api/payment-terms/${id}`,
    NAMES: `${API_BASE_URL}/api/payment-term-names`
  },

  DELIVERY_TERMS:{
    BASE: `${API_BASE_URL}/api/delivery-terms`,
    CREATE : `${API_BASE_URL}/api/delivery-terms`,
    EDIT : (id) => `${API_BASE_URL}/api/delivery-terms/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/delivery-terms/${id}`,
    GET: (id) => `${API_BASE_URL}/api/delivery-terms/${id}`,
    NAMES: `${API_BASE_URL}/api/delivery-term-names`
  },

  PRODUCT_TYPES:{
    BASE: `${API_BASE_URL}/api/product-types`,
    CREATE : `${API_BASE_URL}/api/product-types`,
    EDIT : (id) => `${API_BASE_URL}/api/product-types/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/product-types/${id}`,
    GET: (id) => `${API_BASE_URL}/api/product-types/${id}`,
    PUBLISH : (id) => `${API_BASE_URL}/api/product-types/publish/${id}`,
    PIECES : (id) => `${API_BASE_URL}/api/product-types/pieces/${id}`
  },

  CATEGORIES:{
    BASE: `${API_BASE_URL}/api/categories`,
    CREATE : `${API_BASE_URL}/api/categories`,
    EDIT : (id) => `${API_BASE_URL}/api/categories/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/categories/${id}`,
    GET: (id) => `${API_BASE_URL}/api/categories/${id}`,
    PUBLISH : (id) => `${API_BASE_URL}/api/categories/publish/${id}`
  },
  
  BRANDS:{
    BASE: `${API_BASE_URL}/api/brands`,
    CREATE : `${API_BASE_URL}/api/brands`,
    EDIT : (id) => `${API_BASE_URL}/api/brands/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/brands/${id}`,
    GET: (id) => `${API_BASE_URL}/api/brands/${id}`,
    PUBLISH : (id) => `${API_BASE_URL}/api/brands/publish/${id}`
  },

  APP_USERS:{
    BASE: `${API_BASE_URL}/api/app-users`,
    CREATE : `${API_BASE_URL}/api/app-users`,
    EDIT : (id) => `${API_BASE_URL}/api/app-users/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/app-users/${id}`,
    GET: (id) => `${API_BASE_URL}/api/app-users/${id}`
  },

  CUSTOMER_ORDERS:{
    BASE: `${API_BASE_URL}/api/customer-orders`,
    CREATE : `${API_BASE_URL}/api/customer-orders`,
    EDIT : (id) => `${API_BASE_URL}/api/customer-orders/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/customer-orders/${id}`,
    GET: (id) => `${API_BASE_URL}/api/customer-orders/${id}`
  },

  CUSTOM_ORDER_PRODUCTS: {
    BASE: `${API_BASE_URL}/api/custom-order-products`,
    CREATE: `${API_BASE_URL}/api/custom-order-products`,
    EDIT: (id) => `${API_BASE_URL}/api/custom-order-products/${id}`,
    DELETE: (id) => `${API_BASE_URL}/api/custom-order-products/${id}`,
    GET: (id) => `${API_BASE_URL}/api/custom-order-products/${id}`
  },

  DEALER_QUOTATIONS:{
    BASE: `${API_BASE_URL}/api/dealer-quotations`,
    CREATE : `${API_BASE_URL}/api/dealer-quotations`,
    EDIT : (id) => `${API_BASE_URL}/api/dealer-quotations/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/dealer-quotations/${id}`,
    GET: (id) => `${API_BASE_URL}/api/dealer-quotations/${id}`
  },

  DEALER_QUOTATION_PRODUCTS:{
    BASE: `${API_BASE_URL}/api/dealer-quotation-products`,
    CREATE : `${API_BASE_URL}/api/dealer-quotation-products`,
    EDIT : (id) => `${API_BASE_URL}/api/dealer-quotation-products/${id}`,
    DELETE : (id) => `${API_BASE_URL}/api/dealer-quotation-products/${id}`,
    GET: (id) => `${API_BASE_URL}/api/dealer-quotation-products/${id}`
  },
  APPLICATION_SETTINGS: {
    BASE: `${API_BASE_URL}/api/application-settings`,
    CREATE: `${API_BASE_URL}/api/application-settings`,
    EDIT: (id) => `${API_BASE_URL}/api/application-settings/${id}`,
    DELETE: (id) => `${API_BASE_URL}/api/application-settings/${id}`,
    GET: (id) => `${API_BASE_URL}/api/application-settings/${id}`,
  },

  BULK_UPDATE: `${API_BASE_URL}/api/application-settings/update`,
  USER_TYPE_NAMES: `${API_BASE_URL}/api/user-type-names`,
  CUSTOMER_ORDERS_DETAILS: `${API_BASE_URL}/api/customer-order-details`,
  REGION_NAMES: `${API_BASE_URL}/api/region-names`,
  BRAND_NAMES: `${API_BASE_URL}/api/brand-names`,
  CATEGORY_NAMES: `${API_BASE_URL}/api/category-names`,
  APP_USER_NAMES: `${API_BASE_URL}/api/app-user-names`,
  CUSTOMER_ORDER_DETAILS: `${API_BASE_URL}/api/customer-order-details`,
  PRODUCT_TYPE_NAMES: `${API_BASE_URL}/api/product-type-names`,
  GET_APPLICATION_SETTINGS: `${API_BASE_URL}/api/settings-by-value`,
  DASHBOARD : `${API_BASE_URL}/api/dashboard`,
  DEALER_NAMES: `${API_BASE_URL}/api/get-dealers`,
  CREATE_ENQUIRY: `${API_BASE_URL}/api/create-enquiry`,
  GET_USERS_BY_TYPE:  `${API_BASE_URL}/api/get-usersbytype`,
  DAY_WISE_REVENEW: `${API_BASE_URL}/api/day-wise-revenew`,
  SEND_EMAIL: `${API_BASE_URL}/api/send-email`,
  PAYMENT_TERM_NAMES: `${API_BASE_URL}/api/get-payment-terms`,
  DELIVERY_TERM_NAMES: `${API_BASE_URL}/api/get-delivery-terms`,
  IMPORT_CSV: `${API_BASE_URL}/api/import-csv`,

};

export const API_IMAGE_URL = process.env.REACT_APP_IMAGE_URL || 'http://127.0.0.1:8000/images/'; // Match Laravel default port

// Set axios defaults
axios.defaults.baseURL = API_BASE_URL;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Request interceptor
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // console.log('Request URL:', config.url); // Debug full URL
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      window.location.pathname !== '/login'
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default API_ENDPOINTS;